<template>
    <div id="content-wrapper">
        <template v-if="Object.keys(translations).length > 0">

            <portal-target name="modal" slim></portal-target>

            <router-view></router-view>

            <toaster></toaster>

        </template>
    </div>
</template>

<script>
import Global from './mixins/Global';
import Echo from 'laravel-echo';
const debounce = require('lodash.debounce');

export default {
	name: 'App',

	mixins: [Global],

	methods: {
		saveScreenWidth: debounce(function screenWidth() {
			const window_width = window.innerWidth;

			this.$store.commit('setScreenWidth', window_width);
		}, 250),

		setupPusher() {
			window.Pusher = require('pusher-js');

			window.Echo = new Echo({
				broadcaster: 'pusher',
				key: '5d484c40f8cc039295f6',
				cluster: 'eu',
				encrypted: true,
			});

			// window.Pusher.log = function (message) { window.console.log(message); }
		},

		setupScoreListener() {
			window.Echo.private(`score.${this.$user.id}`)
				.listen('.scoreEvent', (data) => {
					const notifications = data.data.data.notifications;

					if (notifications.length > 0) {
						const scoreData = data.data.data;
						const notification = notifications[0];

						toastr.options = { 'positionClass': 'toast-bottom-right' };

						toastr.success(notification.body_plain +
                                `<div class="user-stats-card">
                                    <div class="user-stats-data">
                                        <div class="user-level light-text">
                                            Level ` + scoreData.level +
                                                        `</div>
                                        <div class="progress-bar-points light-text">
                                            ` + Math.round(scoreData.pointsTillNextLevel) + ` <i class="far fa-tint"></i>
                                        </div>
                                        <div class="progress-bar-wrapper no-select">
                                            <div class="progress-bar-outer mimic-title">
                                                <div class="progress-bar-inner" style="width: ` + scoreData.currentLevelPercentage + `%;">
                                            </div>
                                        </div>
                                    </div>
                                </div>`, notification.title);
					}
				});
		},
	},

	mounted() {
		window.addEventListener('resize', this.saveScreenWidth);

		this.saveScreenWidth();

		this.setupPusher();

		if (this.$user) {
			this.setupScoreListener();
		}
	},
};
</script>

<style lang="less">
    @import '@/resources/assets/less/default/main.less';

    .container[data-id="messages"] {
        width: 100% !important;
        padding:0px !important;
    }

    .page-content[data-id="messages"] {
        padding:0px !important;
        min-height: auto !important;
    }

    #content-wrapper {
        display: flex;
        min-height: calc(100vh - 70px);
        margin-top: 70px;
        background: #F8F8F8;

        .main-content-inner-wrapper {
            @apply tw-flex tw-flex-1 tw-pt-6;

            .main-content-center {
                @media(max-width: 767px) {
                    @apply tw-mt-6;
                }
            }

            &.tw-pt-0 {
                padding-top: 0;
            }
        }

        h1 {
            @apply tw-text-2xl tw-mb-3 tw-font-semibold;
        }

        h2 {
            @apply tw-leading-loose tw-mb-4;
        }

        @media(max-width: 1100px) {
            margin-top: 64px;
            margin-bottom: 51px;
        }

        @media(max-width: 767px) {
            .main-content-inner-wrapper {
                @apply tw-p-0;
            }
        }
    }
</style>
